/*
 * @Author: lc
 * @Date: 2022-07-26 15:09:06
 * @LastEditors: lc
 * @LastEditTime: 2022-07-27 11:27:29
 * @Description: 藏家相关
 */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/';

const collector = {
    // 列表
    list (params) {
        return axios.get(api + 'collector/list', { params: params })
    },
    // 藏品列表
    collectionlist (params) {
        return axios.get(api + 'collector/collectionlist', { params: params })
    },
    // 粉丝列表
    attentionlist (params) {
        return axios.get(api + 'collector/attentionlist', { params: params })
    },
    // 转赠列表
    turnloglist (params) {
        return axios.get(api + 'collector/turnloglist', { params: params })
    },

}


// 导出接口
export default collector
